module.exports = __webpack_public_path__ + "img/mxp_icon.1d60eedd.svg";